export const stakingCardSkeletonStyles = (isDark: boolean) => ({
  rowContainerWallet: {
    mt: 2
  },
  paperSkeleton: {
    background: isDark
      ? 'linear-gradient(rgba(255, 255, 255, 0.04), rgba(255, 255, 255, 0.02))'
      : 'rgba(233, 240, 253, 0.5)',
    borderRadius: '6px',
    boxShadow: isDark
      ? 'rgb(0 0 0 / 20%) 0px 3px 1px -2px, rgb(0 0 0 / 14%) 0px 2px 2px 0px, rgb(0 0 0 / 12%) 0px 1px 5px 0px'
      : 'rgb(0 0 0 / 7%) 0px 8px 13px 2px',
    backdropFilter: 'blur(4px)',
    pr: 1,
    pl: 2,
    mt: 1,
    pb: 1.5
  }
});
